import { ExtractPropTypes, SetupContext } from 'vue'
import { GRANULAR_FEEDBACK_PROPS } from './types'

type GranularFeedbackPropType = ExtractPropTypes<typeof GRANULAR_FEEDBACK_PROPS>
/**
 *
 * @param props
 * @param context
 */
export function setup(props: GranularFeedbackPropType, context: SetupContext) {
  const submitGranularFeedback = (feedbackReason: string) => {
    context.emit('submitGranularFeedback', feedbackReason)
  }

  const buttonIcon = (option: string) =>
    props.granularFeedback === option ? 'check' : undefined

  return {
    submitGranularFeedback,
    buttonIcon,
  }
}
